// Test IDs for the public marketing landing page (site root "/").

export const LANDING = {
  page: 'landing-page',
  loading: 'landing-loading',
  error: 'landing-error',

  header: 'landing-header',
  logo: 'landing-logo',
  navTreatments: 'landing-nav-treatments',
  navDoctor: 'landing-nav-doctor',
  navTeam: 'landing-nav-team', // Fix AZ (2026-10-30)
  navResults: 'landing-nav-results',
  navFaq: 'landing-nav-faq',
  navContact: 'landing-nav-contact',
  langEs: 'landing-lang-es',
  langEn: 'landing-lang-en',
  ctaHeader: 'landing-cta-header',
  mobileMenuToggle: 'landing-mobile-menu-toggle',
  mobileMenu: 'landing-mobile-menu',

  hero: 'landing-hero',
  heroImage: 'landing-hero-image', // Fix BA (2026-10-30): la foto que se ve
  heroSlidePrefix: 'landing-hero-slide-', // + indice (fotos que no se ven)
  heroDots: 'landing-hero-dots',
  heroDotPrefix: 'landing-hero-dot-', // + indice
  heroQuote: 'landing-hero-quote',
  heroCta: 'landing-hero-cta',
  scrollIndicator: 'landing-scroll-indicator',

  intro: 'landing-intro',

  treatments: 'landing-treatments-section',
  categoryTabPrefix: 'landing-category-tab-', // + category|all
  treatmentCardPrefix: 'landing-treatment-card-', // + serviceId
  treatmentPricePrefix: 'landing-treatment-price-', // + serviceId (Fix AT, 2026-10-27)
  treatmentPriceNotePrefix: 'landing-treatment-price-note-', // + serviceId (Fix AT)
  treatmentCardOpenPrefix: 'landing-treatment-card-open-', // + serviceId
  treatmentCtaPrefix: 'landing-treatment-cta-', // + serviceId
  treatmentDetailModal: 'landing-treatment-detail-modal',
  treatmentDetailBookButton: 'landing-treatment-detail-book-button',
  treatmentGalleryPreview: 'landing-treatment-gallery-preview',

  doctorSection: 'landing-doctor-section',

  // Fix AZ (2026-10-30): equipo de profesionales
  teamSection: 'landing-team-section',
  teamCardPrefix: 'landing-team-card-', // + professionalId
  teamWhatsapp: 'landing-team-whatsapp',

  resultsSection: 'landing-results-section',
  galleryItemPrefix: 'landing-gallery-item-', // + id
  galleryFilterPrefix: 'landing-gallery-filter-', // + serviceId|all
  galleryVideoPrefix: 'landing-gallery-video-', // + id

  testimonialsSection: 'landing-testimonials-section',
  testimonialCardPrefix: 'landing-testimonial-card-', // + id

  // Fix BD (2026-10-30): novedades de redes
  newsSection: 'landing-news-section',
  newsCardPrefix: 'landing-news-card-', // + postId
  newsFollowPrefix: 'landing-news-follow-', // + instagram|facebook

  featuredBookingSection: 'landing-featured-booking-section',
  featuredBookingCardPrefix: 'landing-featured-booking-card-', // + serviceId

  faqSection: 'landing-faq-section',
  faqItemPrefix: 'landing-faq-item-', // + id

  visitSection: 'landing-visit-section',
  visitMap: 'landing-visit-map',

  closingCta: 'landing-closing-cta',
  closingCtaButton: 'landing-closing-cta-button',

  footer: 'landing-footer',
  footerInstagram: 'landing-footer-instagram',
  footerFacebook: 'landing-footer-facebook',
  footerPaymentMethods: 'landing-footer-payment-methods',

  whatsappButton: 'landing-whatsapp-button',
};

// Test IDs for the admin panel that manages landing page content
// (Configuracion > Contenido de la landing / Testimonios / Galeria de resultados).
export const LANDING_ADMIN = {
  profileLink: 'landing-admin-profile-link',
  contentCard: 'landing-admin-content-card',
  heroImageUpload: 'landing-admin-hero-image-upload',
  // Fix BA (2026-10-30): fotos de la portada
  heroImagesList: 'landing-admin-hero-images-list',
  heroImageRowPrefix: 'landing-admin-hero-image-row-', // + indice
  heroImagePositionPrefix: 'landing-admin-hero-image-position-', // + indice
  heroImageUpPrefix: 'landing-admin-hero-image-up-', // + indice
  heroImageDownPrefix: 'landing-admin-hero-image-down-', // + indice
  heroImageRemovePrefix: 'landing-admin-hero-image-remove-', // + indice
  heroTitleInput: 'landing-admin-hero-title-input',
  heroSubtitleInput: 'landing-admin-hero-subtitle-input',
  heroQuoteInput: 'landing-admin-hero-quote-input',
  introTitleInput: 'landing-admin-intro-title-input',
  introTextInput: 'landing-admin-intro-text-input',
  businessHoursInput: 'landing-admin-business-hours-input',
  showGalleryToggle: 'landing-admin-show-gallery-toggle',
  metaTitleInput: 'landing-admin-meta-title-input',
  metaDescriptionInput: 'landing-admin-meta-description-input',
  saveContentButton: 'landing-admin-save-content-button',

  testimonialsCard: 'landing-admin-testimonials-card',
  testimonialAddButton: 'landing-admin-testimonial-add-button',
  testimonialTypeToggle: 'landing-admin-testimonial-type-toggle', // "texto" | "imagen"
  testimonialNameInput: 'landing-admin-testimonial-name-input',
  testimonialTextInput: 'landing-admin-testimonial-text-input',
  testimonialImageUpload: 'landing-admin-testimonial-image-upload',
  testimonialServiceSelect: 'landing-admin-testimonial-service-select',
  testimonialRatingInput: 'landing-admin-testimonial-rating-input',
  testimonialSaveButton: 'landing-admin-testimonial-save-button',
  testimonialCancelButton: 'landing-admin-testimonial-cancel-button',
  testimonialRowPrefix: 'landing-admin-testimonial-row-', // + id
  testimonialDeleteButtonPrefix: 'landing-admin-testimonial-delete-', // + id
  testimonialActiveTogglePrefix: 'landing-admin-testimonial-active-', // + id

  galleryCard: 'landing-admin-gallery-card',
  galleryAddButton: 'landing-admin-gallery-add-button',
  galleryTypeSelect: 'landing-admin-gallery-type-select', // "single" | "pair" | "video"
  gallerySingleUpload: 'landing-admin-gallery-single-upload',
  galleryBeforeUpload: 'landing-admin-gallery-before-upload',
  galleryAfterUpload: 'landing-admin-gallery-after-upload',
  galleryVideoUpload: 'landing-admin-gallery-video-upload',
  galleryServiceSelect: 'landing-admin-gallery-service-select',
  galleryCaptionInput: 'landing-admin-gallery-caption-input',
  gallerySaveButton: 'landing-admin-gallery-save-button',
  galleryCancelButton: 'landing-admin-gallery-cancel-button',
  galleryRowPrefix: 'landing-admin-gallery-row-', // + id
  galleryDeleteButtonPrefix: 'landing-admin-gallery-delete-', // + id

  // Fix BD (2026-10-30): novedades de redes
  newsCard: 'landing-admin-news-card',
  newsAddButton: 'landing-admin-news-add-button',
  newsImageUpload: 'landing-admin-news-image-upload',
  newsPlatformSelect: 'landing-admin-news-platform-select',
  newsLinkInput: 'landing-admin-news-link-input',
  newsCaptionInput: 'landing-admin-news-caption-input',
  newsSaveButton: 'landing-admin-news-save-button',
  newsCancelButton: 'landing-admin-news-cancel-button',
  newsRowPrefix: 'landing-admin-news-row-', // + id
  newsActiveTogglePrefix: 'landing-admin-news-active-', // + id
  newsDeleteButtonPrefix: 'landing-admin-news-delete-', // + id
  newsDeleteConfirmButton: 'landing-admin-news-delete-confirm',

  galleryBulkUploadButton: 'landing-admin-gallery-bulk-upload-button',
  galleryBulkModal: 'landing-admin-gallery-bulk-modal',
  galleryBulkDropzone: 'landing-admin-gallery-bulk-dropzone',
  galleryBulkFileInput: 'landing-admin-gallery-bulk-file-input',
  galleryBulkTable: 'landing-admin-gallery-bulk-table',
  galleryBulkRowPrefix: 'landing-admin-gallery-bulk-row-', // + index
  galleryBulkServiceSelectPrefix: 'landing-admin-gallery-bulk-service-select-', // + index
  galleryBulkRemoveButtonPrefix: 'landing-admin-gallery-bulk-remove-button-', // + index
  galleryBulkNoMatchBadgePrefix: 'landing-admin-gallery-bulk-no-match-badge-', // + index
  galleryBulkConfirmButton: 'landing-admin-gallery-bulk-confirm-button',
  galleryBulkCancelButton: 'landing-admin-gallery-bulk-cancel-button',
  galleryBulkBackButton: 'landing-admin-gallery-bulk-back-button',
  galleryBulkResultSummary: 'landing-admin-gallery-bulk-result-summary',
  galleryBulkProgress: 'landing-admin-gallery-bulk-progress',

  testimonialEditButtonPrefix: 'landing-admin-testimonial-edit-', // + id
  testimonialNameEditInputPrefix: 'landing-admin-testimonial-name-edit-input-', // + id
  testimonialNameEditSaveButtonPrefix: 'landing-admin-testimonial-name-edit-save-', // + id
  testimonialNameEditCancelButtonPrefix: 'landing-admin-testimonial-name-edit-cancel-', // + id

  testimonialBulkUploadButton: 'landing-admin-testimonial-bulk-upload-button',
  testimonialBulkModal: 'landing-admin-testimonial-bulk-modal',
  testimonialBulkDropzone: 'landing-admin-testimonial-bulk-dropzone',
  testimonialBulkFileInput: 'landing-admin-testimonial-bulk-file-input',
  testimonialBulkTable: 'landing-admin-testimonial-bulk-table',
  testimonialBulkRowPrefix: 'landing-admin-testimonial-bulk-row-', // + index
  testimonialBulkNameInputPrefix: 'landing-admin-testimonial-bulk-name-input-', // + index
  testimonialBulkRemoveButtonPrefix: 'landing-admin-testimonial-bulk-remove-button-', // + index
  testimonialBulkConfirmButton: 'landing-admin-testimonial-bulk-confirm-button',
  testimonialBulkCancelButton: 'landing-admin-testimonial-bulk-cancel-button',
  testimonialBulkResultSummary: 'landing-admin-testimonial-bulk-result-summary',
  testimonialBulkProgress: 'landing-admin-testimonial-bulk-progress',
};
